import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './ShipDisplayField.scss'

export default class ShipDisplayField extends PureComponent {
  static propTypes = {
    category: PropTypes.string.isRequired,
    value: PropTypes.string,
    required: PropTypes.bool,
    error: PropTypes.string
  }

  render() {
    return (
      <div className="ship-detail-group">
        <span className={`ship-detail category ${this.props.error ? 'error' : ''}`}>
          {this.props.category}
          {this.props.required ? ' *' : null}
        </span>
        <span className={`ship-detail value ${this.props.error ? 'error' : ''}`}>
          {this.props.value ? this.props.value : '-'}
        </span>
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }
}
